import { render } from "./jyps.vue?vue&type=template&id=f753b82c&scoped=true&ts=true"
import script from "./jyps.vue?vue&type=script&lang=ts"
export * from "./jyps.vue?vue&type=script&lang=ts"

import "./jyps.vue?vue&type=style&index=0&id=f753b82c&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f753b82c"]])

export default __exports__